import React from "react";
import { Logo, ServiceBar } from "@/components/Logo";

export function DocumentHeader({ company }) {
  const slogan = company?.slogan || "SOLUCIONES DE VANGUARDIA";
  const services = company?.service_bar
    ? company.service_bar
    : "SUBESTACIONES · PROYECTOS · OBRA CIVIL · GESTORÍA · UVIES · INSTALACIONES · MANTENIMIENTO";
  return (
    <div className="w-full bg-white border-b border-[color:var(--pe-border)]">
      <div className="max-w-4xl mx-auto px-6 py-4 flex items-start justify-between gap-4">
        <Logo src={company?.logo_url} height={62} />
        <div className="text-right">
          <div className="text-[11px] sm:text-sm font-black tracking-[0.16em] text-[color:var(--pe-primary)]">
            {slogan}
          </div>
          {company?.rfc && <div className="text-xs text-slate-500 mt-1">RFC: {company.rfc}</div>}
          {company?.phone && <div className="text-xs text-slate-500">Tel: {company.phone}</div>}
        </div>
      </div>
      <ServiceBar text={services} />
    </div>
  );
}

export function DocumentFooter({ company }) {
  const parts = [company?.address, company?.phone, company?.email].filter(Boolean);
  return (
    <div className="w-full bg-[color:var(--pe-primary)] text-white text-center py-3 px-4 text-xs">
      {parts.length ? parts.join(" · ") : company?.name || "POWER & ENERGY"}
    </div>
  );
}

export default DocumentHeader;
